const VerificaForm = (form: HTMLFormElement | null) => {
  let verificado = true;

  if (form) {
    Array.from(form.elements).forEach((element) => {
      if (verificado) {
        const input = element as HTMLInputElement;
        const value = input.value;
        if (
          value.length < input.minLength ||
          value < input.min ||
          (input.max && value > input.max) ||
          (input.required && value.length < 1)
        ) {
          input.setCustomValidity(" ");
          input.reportValidity(); //Eu não sei o porque, mas isso funciona

          verificado = false;
        }
      }
    });
  }
  return verificado;
};

export default VerificaForm;
